/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
    }
};

(function() {
    BoostPFS.inject(this);

    // ============================================================
    // FIX: Search queries containing apostrophes
    // ============================================================
    // Boost's search submit handler can fail when the query contains
    // a straight apostrophe (') or curly apostrophe (’).
    //
    // Shopify search itself supports these queries correctly, so
    // only apostrophe searches are intercepted here and sent directly
    // to the normal Shopify /search URL.
    //
    // All other searches continue through Boost normally.
    // ============================================================
    (function() {
        function hasApostrophe(value) {
            return /['’]/.test(value || '');
        }

        function getSearchInput(form) {
            if (!form) return null;

            return form.querySelector(
                'input[name="q"], .boost-pfs-search-input, .boost-pfs-search-box'
            );
        }

        function runSearch(form, input) {
            if (!input || !hasApostrophe(input.value)) return;

            var query = input.value.trim().replace(/’/g, "'");
            if (!query) return;

            var root = '/';

            if (
                typeof Shopify !== 'undefined' &&
                Shopify.routes &&
                Shopify.routes.root
            ) {
                root = Shopify.routes.root;
            }

            if (root.slice(-1) !== '/') {
                root += '/';
            }

            var action = form && form.getAttribute('action')
                ? form.getAttribute('action')
                : root + 'search';

            var url;

            try {
                url = new URL(action, window.location.origin);
            } catch (e) {
                url = new URL(root + 'search', window.location.origin);
            }

            // Preserve any existing hidden search-form settings.
            if (form && typeof FormData !== 'undefined') {
                var formData = new FormData(form);

                formData.forEach(function(value, key) {
                    if (
                        key !== 'q' &&
                        typeof value === 'string' &&
                        value !== ''
                    ) {
                        url.searchParams.append(key, value);
                    }
                });
            }

            url.searchParams.set('q', query);

            window.location.assign(url.toString());
        }

        function stopBoostAndSearch(event, form, input) {
            if (!input || !hasApostrophe(input.value)) return false;

            event.preventDefault();
            event.stopPropagation();

            if (typeof event.stopImmediatePropagation === 'function') {
                event.stopImmediatePropagation();
            }

            runSearch(form, input);

            return true;
        }

        // Pressing Enter in a search field
        document.addEventListener('keydown', function(event) {
            if (event.key !== 'Enter' && event.keyCode !== 13) return;

            var input = event.target;

            if (
                !input ||
                !input.matches(
                    'input[name="q"], .boost-pfs-search-input, .boost-pfs-search-box'
                )
            ) {
                return;
            }

            var form = input.closest('form');

            stopBoostAndSearch(event, form, input);
        }, true);

        // Normal form submission
        document.addEventListener('submit', function(event) {
            var form = event.target;
            var input = getSearchInput(form);

            stopBoostAndSearch(event, form, input);
        }, true);

        // Search button click
        document.addEventListener('click', function(event) {
            if (!event.target || !event.target.closest) return;

            var button = event.target.closest(
                'button[type="submit"], input[type="submit"]'
            );

            if (!button) return;

            var form = button.closest('form');
            var input = getSearchInput(form);

            stopBoostAndSearch(event, form, input);
        }, true);
    })();

    // === Boost ISW: Add product metafield under product title ===
    // Pulls custom.search_subtitle from Boost Instant Search product data.
    var boostISWMetafieldNamespace = 'custom';
    var boostISWMetafieldKey = 'search_subtitle';

    (function() {
        if (
            typeof InstantSearchResultItemProduct === 'undefined' ||
            typeof InstantSearchResultItemProduct.prototype === 'undefined'
        ) {
            return;
        }

        var originalSetData = InstantSearchResultItemProduct.prototype.setData;
        var originalGetTemplate = InstantSearchResultItemProduct.prototype.getTemplate;
        var originalCompileTemplate = InstantSearchResultItemProduct.prototype.compileTemplate;

        InstantSearchResultItemProduct.prototype.setData = function(data) {
            originalSetData.call(this, data);

            this.boostISWMetafield = '';

            if (
                data &&
                typeof Utils !== 'undefined' &&
                typeof Utils.getProductMetafield === 'function'
            ) {
                this.boostISWMetafield = Utils.getProductMetafield(
                    data,
                    boostISWMetafieldNamespace,
                    boostISWMetafieldKey
                ) || '';
            }

            this.boostISWMetafield = this.boostISWMetafield
                ? Utils.stripHtml(this.boostISWMetafield)
                : '';
        };

        InstantSearchResultItemProduct.prototype.getTemplate = function(type) {
            var template = originalGetTemplate.call(this, type);

            // Only update the main product item template.
            // This does not modify image, SKU, vendor, or price sub-templates.
            if (!type && template.indexOf('{{boostISWMetafield}}') === -1) {
                template = template.replace(
                    '<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>',
                    '<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>{{boostISWMetafield}}'
                );
            }

            return template;
        };

        InstantSearchResultItemProduct.prototype.compileTemplate = function() {
            var html = originalCompileTemplate.call(this);

            var metafieldHtml = this.boostISWMetafield
                ? '<p class="boost-pfs-search-suggestion-product-metafield">' + this.boostISWMetafield + '</p>'
                : '';

            return html.replace('{{boostISWMetafield}}', metafieldHtml);
        };
    })();

    // Clear button for the Form Search
    HTMLDocument.prototype.ready = function() {
        return new Promise(function(resolve, reject) {
            if (document.readyState === 'complete') {
                resolve(document);
            } else {
                document.addEventListener('DOMContentLoaded', function() {
                    resolve(document);
                });
            }
        });
    }

    document.ready().then(function() {
        var inputSearchFormSelector = jQ('.boost-pfs-search-input');
        var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

        if (!!inputSearchFormSelector.val()) {
            clearSearchFormSelector.show();
        }

        inputSearchFormSelector.on('change keydown keyup', function() {
            if (!!jQ(this).val()) {
                clearSearchFormSelector.show();
            } else {
                clearSearchFormSelector.hide();
            }
        });

        clearSearchFormSelector.on("click", function() {
            inputSearchFormSelector.val("");
            jQ(this).hide();
            inputSearchFormSelector.click();
        });
    }); // End Clear button for the Form Search

    // Customize style of Suggestion box
    SearchInput.prototype.customizeInstantSearch = function() {
        var suggestionElement = this.$uiMenuElement;
        var searchElement = this.$element;
        var searchBoxId = this.id;
    };

    // Bind Event for input search Mobile
    var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
    InstantSearchMobile.prototype.bindEvents = function() {
        bindEventsMobile.call(this);

        var self = this;
        var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
        var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
        var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';

        jQ(searchButtonMobile).off('click').click(function(e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputMobile).focus();
            self.openSuggestionMobile();
            jQ(searchCloseButtonMobile).trigger('click');
        });
    }

    // Bind Event for input search style 3
    var bindEvents = InstantSearchStyle3.prototype.bindEvents;
    InstantSearchStyle3.prototype.bindEvents = function() {
        bindEvents.call(this);

        var self = this;
        var searchButtonDesktop = '.site-header__links .search-button';
        var searchInputDesktop = '#SearchContainer #search-input';
        var searchCloseButtonDesktop = '.drawer__close > button';

        jQ(searchButtonDesktop).off('click').click(function(e) {
            e.preventDefault();
            //e.stopPropagation();
            jQ(searchInputDesktop).focus();
            self.openSuggestionStyle3();
            jQ(searchCloseButtonDesktop).trigger('click');
        });
    }

    // Fix search for the Flow theme
    jQ('.site-header__links .search-button').on('click', function() {
        setTimeout(function() {
            boostPFS.initSearchBox();

            if (Utils.isCollectionPage()) {
                jQ('.search-input-group > .boost-pfs-search-box').val('');
            }
        }, 500);
    });

    Utils.buildProductItemUrl = function(data, hasCollection) {
        // Get url information
        var params = Utils.getWindowLocation().search.substring(1);
        var pathname = window.location.pathname;
        var elements = pathname.split('/');

        // Check if has locale
        var localeURLPart = "";
        var hasShopifyRoutes =
            Shopify &&
            Shopify.routes &&
            typeof Shopify.routes.root != 'undefined';

        if (
            Settings.getSettingValue('general.useShopifyRouteForMultiLanguageURL') &&
            hasShopifyRoutes
        ) {
            localeURLPart = Shopify.routes.root.replace(/\/$/, '');
        } else if (
            elements.indexOf(boostPFSAppConfig.general.current_locale) > -1
        ) {
            localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
        }

        // Get product handle
        var handle =
            typeof data === 'object' && data.hasOwnProperty('handle')
                ? data.handle
                : data;

        var hasCollection =
            typeof hasCollection !== 'undefined'
                ? hasCollection
                : Settings.getSettingValue(
                    'general.addCollectionToProductUrl'
                );

        if (hasCollection) {
            // Homepage or Search page
            if (
                pathname == '/' ||
                Utils.isSearchPage() ||
                Utils.isVendorPage() ||
                Utils.isTypePage()
            ) {
                var preHandle =
                    localeURLPart + '/collections/all/products/';

                return preHandle + handle;

            // Tag Page
            } else if (Utils.isTagPage()) {
                var preHandle = localeURLPart + '/collections/';
                var collectionHandleIndex =
                    elements.indexOf("collections") + 1;

                if (elements.length >= 4) {
                    return (
                        preHandle +
                        elements[collectionHandleIndex] +
                        '/products/' +
                        handle
                    );
                }

                return '/collections/all/products/' + handle;

            } else {
                // Google cache URL
                // Example:
                // webcache.googleusercontent.com/search?q=cache:...
                if (params.indexOf('cache:') > -1) {
                    var collectionHandle = 'all';

                    var temp = params
                        .split('&')[0]
                        .split('?')[0]
                        .split('collections/');

                    if (temp.length > 1) {
                        if (temp[1].indexOf('/') > -1) {
                            collectionHandle = temp[1].split('/')[0];
                        } else {
                            collectionHandle = temp[1];
                        }
                    }

                    // Remove characters that should not be part
                    // of the collection handle.
                    collectionHandle = collectionHandle.replace(
                        /[`~!@#$%^&*()_|+\=?;:'",.<>{}\[\]\\\/]/g,
                        ''
                    );

                    return (
                        '/collections/' +
                        collectionHandle +
                        '/products/' +
                        handle
                    );
                }

                var collectionHandleIndex =
                    elements.indexOf("collections") + 1;

                var preHandle =
                    localeURLPart + '/collections/';

                if (typeof elements[2] !== 'undefined') {
                    // Build for collection pages
                    if (
                        (localeURLPart == '' &&
                            elements[1] === 'collections') ||
                        localeURLPart != ''
                    ) {
                        return (
                            preHandle +
                            elements[collectionHandleIndex] +
                            '/products/' +
                            handle
                        );
                    }

                    return (
                        preHandle +
                        'all' +
                        elements[collectionHandleIndex] +
                        '/products/' +
                        handle
                    );

                } else if (
                    typeof elements[2] === 'undefined' &&
                    localeURLPart == ''
                ) {
                    return '/products/' + handle;
                }

                return (
                    window.location.pathname +
                    '/products/' +
                    handle
                );
            }
        }

        return localeURLPart + '/products/' + handle;
    };
})();